import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { ExchangeRate } from '../models';
import { AlloxApiService } from './allox-api.service';

@Injectable({ providedIn: 'root' })
export class ExchangeRateService {

  private path = '/exchange_rates';

  constructor(private http: AlloxApiService) { }

  public search() {
    return this.http.get(this.path + '/' + 'usd').pipe(
      map(obj => new ExchangeRate(obj))
    );
  }

  public put(item: ExchangeRate) {
    const json = item.toJSON();
    return this.http.put(this.path + '/' + 'usd', json);
  }
}
